import React, { useState, useEffect } from 'react';
import { api } from '../App';
import '../styles/BestellingDetailsPage.css';
import PageLoader from '../components/PageLoader';

function BestellingDetailsPage({ user, bestellingId, onBack, onLogout, onEditOrder }) {
  const [bestelling, setBestelling] = useState(null);
  const [regels, setRegels] = useState([]);
  const [vrijeRegels, setVrijeRegels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const fetchBestellingDetails = async () => {
      try {
        const response = await api.get(`/index.php?action=bestellingdetails&bstlid=${bestellingId}`);
        if (cancelled) return;
        setBestelling(response.data.bestelling);
        setRegels(response.data.regels);
        setVrijeRegels(response.data.vrije_regels || []);
        setLoading(false);
      } catch (err) {
        if (cancelled) return;
        setError('Fout bij laden van bestelling');
        setLoading(false);
      }
    };

    fetchBestellingDetails();
    return () => {
      cancelled = true;
    };
  }, [bestellingId]);

  if (loading) {
    return <PageLoader />;
  }

  if (!bestelling) {
    return (
      <div className="bestelling-details-container">
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
          <p>Bestelling niet gevonden</p>
          <button onClick={onBack} className="primary-button">Terug</button>
        </div>
      </div>
    );
  }

  return (
    <div className="bestelling-details-container">
      <header className="bestelling-header">
        <button onClick={onBack} className="back-button">← Terug naar overzicht</button>
        <h1>Bestelling details</h1>
        <button onClick={onLogout} className="logout-button">Uitloggen</button>
      </header>

      <main className="bestelling-main">
        <div className="details-content">
          {error && <div className="error-message">{error}</div>}

          <div className="bestelling-info">
            <div className="info-card">
              <h3>Bestellingsinformatie</h3>
              <div className="info-row">
                <label>Bestelnummer:</label>
                <span>#{bestelling.ID}</span>
              </div>
              <div className="info-row">
                <label>Besteldatum:</label>
                <span>{bestelling.besteldatum}</span>
              </div>
              <div className="info-row">
                <label>Leverdatum:</label>
                <span>{bestelling.leverdatum}</span>
              </div>
              <div className="info-row">
                <label>Status:</label>
                <span className={`status status-${bestelling.status === 0 ? 'open' : 'gesloten'}`}>
                  {bestelling.status === 0 ? 'Open' : 'Gesloten'}
                </span>
              </div>
              {bestelling.notitie && (
                <div className="info-row info-row-notitie">
                  <label>Notitie:</label>
                  <span className="bestelling-notitie-text">{bestelling.notitie}</span>
                </div>
              )}
            </div>

            <div className="regels-card">
              <h3>De bestelling</h3>
              {regels.length === 0 && vrijeRegels.length === 0 ? (
                <p>Geen regels gevonden</p>
              ) : (
                <>
                  <ul className="regels-cards">
                    {regels.map((regel) => (
                      <li key={regel.ID} className="regel-card">
                        <span className="regel-card-qty">{regel.hoeveelheid}×</span>
                        <div className="regel-card-body">
                          <strong>{regel.product}</strong>
                          {regel.eenheid && <span className="regel-card-unit">{regel.eenheid}</span>}
                        </div>
                      </li>
                    ))}
                    {vrijeRegels.map((regel) => (
                      <li key={`vrij-${regel.ID}`} className="regel-card regel-card-anders">
                        <span className="regel-card-qty">{regel.hoeveelheid}×</span>
                        <div className="regel-card-body">
                          <strong>{regel.omschrijving}</strong>
                          <span className="anders-label">(Anders)</span>
                        </div>
                      </li>
                    ))}
                  </ul>

                  <div className="table-scroll-wrapper">
                    <table className="regels-table regels-table-desktop">
                      <thead>
                        <tr>
                          <th>Hoeveelheid</th>
                          <th>Product</th>
                          <th>Eenheid</th>
                        </tr>
                      </thead>
                      <tbody>
                        {regels.map((regel) => (
                          <tr key={regel.ID}>
                            <td className="quantity">{regel.hoeveelheid}</td>
                            <td>{regel.product}</td>
                            <td>{regel.eenheid || '-'}</td>
                          </tr>
                        ))}
                        {vrijeRegels.map((regel) => (
                          <tr key={`vrij-${regel.ID}`}>
                            <td className="quantity">{regel.hoeveelheid}</td>
                            <td>{regel.omschrijving} <span className="anders-label">(Anders)</span></td>
                            <td>-</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>

            {bestelling.status === 0 && (
              <div className="action-section">
                <button
                  onClick={() => onEditOrder(bestellingId)}
                  className="edit-action-button"
                >
                  ✎ Bewerk bestelling
                </button>
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}

export default BestellingDetailsPage;
